import React from 'react';
import {
    Container, Paper, Box, Typography, Divider,
} from '@material-ui/core';
import LocationOffIcon from '@material-ui/icons/LocationOff';
import { useTimeClockIPAccessDeniedStyles } from 'styles/modules/timeclock/TimeClockStyles';

const TimeClockIPAccessDenied = () => {
    const classes = useTimeClockIPAccessDeniedStyles();
    return (
        <Container component="main" className={classes.accessDeniedContainer}>
            <Paper elevation={3} className={classes.accessDeniedCard}>
                <Box className={classes.accessDeniedIconWrapper}>
                    <LocationOffIcon className={classes.accessDeniedIcon} />
                </Box>
                <Typography variant="h5" className={classes.accessDeniedTitle} gutterBottom>
                    Access Denied
                </Typography>
                <Typography variant="body2" color="textSecondary" paragraph>
                    You cannot access the timeclock from this location. Clock-in operations are restricted to the primary dealership network.
                </Typography>
                <Divider className={classes.accessDeniedDivider} />
                <Typography variant="caption" color="textSecondary">
                    If you believe this is an error, please contact your System Administrator.
                </Typography>
            </Paper>
        </Container>
    );
};

export default TimeClockIPAccessDenied;
